import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { channelActions } from '../../../_actions';
import { Input } from '../../../_components';

import OneSignal from '../../../_assets/onesignal-logo.png';

import moment from 'moment';

class OneSignalModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oneSignalAppId: null,
      oneSignalApiId: null,
      submitting: false,
      submitted: false
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.activeChannels.forEach(element => {
      if (element.channel_type === 'ONE_SIGNAL') {
        this.setState({
          oneSignalAppId: element.properties.oneSignalAppId,
          oneSignalApiId: element.properties.oneSignalApiId,
          uuid: element.uuid
        })
      }
    });
  }

  handleChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({[name]: value});
  }

  handleSubmit(e) {
    e.preventDefault();

    let self = this;

    const { oneSignalAppId, oneSignalApiId, uuid } = this.state;
    const { dispatch, actionType } = this.props;
    
    this.setState({submitting: true, submitted: true});
    
    if ( !oneSignalAppId && !oneSignalApiId ) 
      return this.setState({submitting: false});

    let obj = {
      "channel": {
        "domain_uuid": JSON.parse(sessionStorage.getItem('selected_domain')).uuid,
        "channel_type": "ONE_SIGNAL",
        "properties": {
          "oneSignalAppId": oneSignalAppId,
          "oneSignalApiId": oneSignalApiId
        }
      }
    }

    if (actionType === 'view')
      return false

    let action
    let constant
    
    if (actionType === 'edit') {
      obj.channel['uuid'] = uuid;

      action = channelActions.update(obj);
      constant = 'UPDATE_INTEGRATION_FAILURE';
    } else {
      action = channelActions.create(obj);
      constant = 'CHANNEL_INTEGRATION_FAILURE';
    }

    dispatch(action)
      .then(data => {
        if ( data.type !== constant ) {
          this.props.evt.handleSubmit();

          self.setState({submitting: false});
  
          return toast.success(data.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-success'
          });
        }
  
        self.setState({submitting: false})
  
        return toast.error(data.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error'
        });
      });
  }

  render() {
    const { submitted, submitting, oneSignalAppId, oneSignalApiId } = this.state;
    const { actionType } = this.props;

    let title;
    let subtitle;
    let button;
    let buttonLoading;

    switch (actionType) {
      case 'edit':
        title = 'Editing OneSignal channel'
        subtitle = 'It is necessary that you provide your OneSignal appId in the field below.'
        button = 'Edit'
        buttonLoading = 'Editing...'
        break;
      case 'view':
        title = 'OneSignal channel information for this Domain'
        subtitle = 'Here you can you find the configured information for this channel.'
        break;
      default:
        title = 'Adding OneSignal channel'
        subtitle = 'It is necessary that you provide your OneSignal appId in the field below.'
        button = 'Add'
        buttonLoading = 'Adding...'
        break;
    }

    return (
      <div className="modal fade" id={this.props.name+'Modal'} tabIndex="-1" role="dialog" aria-labelledby={this.props.name+'ModalLabel'} aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <img src={OneSignal} alt="OneSignal logo"/>
              <br/>
              <br/>
              <p className="title">{title}</p>
              <p className="disclaimer">{subtitle}</p>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <i className="lnr lnr-cross"></i>
              </button>

              {
                actionType !== 'view' ?
                  <form action="#" className="form clearfix" id="oneSignalChannelForm" method="POST" onSubmit={this.handleSubmit}>
                    <div className="content-group">
                      <Input
                        label="APP ID"
                        type="text"
                        name="oneSignalAppId"
                        submitted={submitted}
                        property={oneSignalAppId}
                        hasChanged={this.handleChange}
                        onError="Provide your OneSignal APP ID"
                      />

                      <Input
                        label="API Token"
                        type="password"
                        name="oneSignalApiId"
                        submitted={submitted}
                        property={oneSignalApiId}
                        hasChanged={this.handleChange}
                        onError="Provide your OneSignal API Token"
                      />
                    </div>

                    {
                      submitting ?
                        <button type="button" className="btn btn-blue float-right disabled" disabled>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          <span className="sr-only"> {buttonLoading}</span>
                        </button>    
                      : <button type="submit" className="btn btn-blue float-right">{button}</button>
                    }
                  </form>
                  : <OneSignalCodeView appId={oneSignalAppId} />
              }
              {
                actionType ?
                  <p className="edit">Last update: {moment(this.state.updated_at).format('MMMM Do YYYY, h:mm:ss a')}</p>
                : ''
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class OneSignalCodeView extends Component {
  render() {
    return (
      <div className="code-area clearfix">
        <p>Copy the code below and paste over your OneSignal code inside your main page.</p> 

        <pre>
          <code>
            {`<script>
  var OneSignal = window.OneSignal || [];
  OneSignal.push(function() {
    OneSignal.init({ appId: '${this.props.appId}', });
    OneSignal.sendTags({ geroUserId: Gero.getUserId() });
  });
</script>`
            }
          </code>
        </pre>

        <button type="button" className="btn btn-blue float-right" data-dismiss="modal" aria-label="Close">OK</button>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { channelStatus } = state.createChannel;
  return channelStatus;
}

const ConnectedOneSignalModal = connect(mapStateToProps)(OneSignalModal);
export { ConnectedOneSignalModal as OneSignalModal }